<template>
    <div>
        <v-form v-model="valid" ref="form">
            <div class="tw-mx-auto lg:tw-px-0">
                <div class="tw-flex tw-flex-wrap md:tw-flex-no-wrap md:tw-space-x-5">
                    <div class="tw-w-full">
                        <v-text-field
                            v-model="form.name"
                            :rules="[v => !!v || 'Debe introducir un nombre']"
                            placeholder="Nombre"
                            required
                            outlined
                            background-color="#fff"
                        ></v-text-field>
                    </div>
                    <div class="tw-w-full">
                        <v-text-field
                            v-model="form.phone"
                            :rules="[v => !!v || 'Debe introducir un teléfono']"
                            placeholder="Telefono"
                            required
                            outlined
                            background-color="#fff"
                            @keypress="isNumber($event)"
                        ></v-text-field>
                    </div>
                    <div class="tw-w-full">
                        <v-text-field
                            v-model="form.email"
                            :rules="emailRules"
                            placeholder="Email"
                            required
                            outlined
                            background-color="#fff"
                        ></v-text-field>
                    </div>
                </div>
                <div class="tw-col-span-3">
                    <v-textarea
                        v-model="form.message"
                        :rules="messageRules"
                        name="message"
                        placeholder="Mensaje"
                        outlined
                        background-color="#fff"
                    ></v-textarea>
                </div>
                <div class="tw-flex tw-flex-col tw-items-center tw-space-y-4">
                    <spinner-button-component class="btn-primary" :loading="loading" @click="validate">
                        Enviar
                    </spinner-button-component>
                </div>
            </div>
        </v-form>

        <!-- Snackbar for success/error messages -->
        <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.color"
            :timeout="snackbar.timeout"
            top
            right
            :class="snackbar.color === 'success' ? 'success-snackbar' : 'error-snackbar'"
            elevation="6"
            rounded="lg"
        >
            <div class="tw-flex tw-items-center tw-space-x-3">
                <!-- Icon -->
                <div class="tw-flex-shrink-0">
                    <svg v-if="snackbar.color === 'success'" class="tw-w-7 tw-h-7 tw-text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <svg v-else class="tw-w-7 tw-h-7 tw-text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>

                <!-- Message -->
                <div class="tw-flex-1 tw-text-white tw-font-semibold tw-text-base tw-leading-relaxed">
                    {{ snackbar.message }}
                </div>

                <!-- Close button -->
                <button
                    @click="snackbar.show = false"
                    class="tw-flex-shrink-0 tw-text-white hover:tw-text-gray-200 tw-transition-colors tw-duration-200 tw-ml-4"
                >
                    <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    data() {
        return {
            valid: false,
            emailRules: [
                v => !!v || 'Debe introducir un email',
                v => /.+@.+\..+/.test(v) || 'Debe introducir un email válido',
            ],
            messageRules: [
                v => !!v || 'Debe introducir un mensaje',
                v => v.length >= 12 || 'El mensaje debe contener al menos 12 caracteres',
            ],
            form: {
                name: '',
                phone: '',
                email: '',
                message: ''
            },
            loading: false,
            snackbar: {
                show: false,
                message: '',
                color: 'success',
                timeout: 5000
            }
        }
    },

    methods: {
        isNumber(event) {
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.preventDefault();
            }
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.submit();
            }
        },
        async submit() {
            this.loading = true;

            try {
                // Get reCAPTCHA token
                const token = await this.getRecaptchaToken();

                // Submit form with reCAPTCHA token
                const response = await axios.post('/api/contact', {
                    ...this.form,
                    'g-recaptcha-response': token
                });

                // Check if response indicates success
                if (response.data.success || response.data.message === 'OK') {
                    // Reset form on success
                    this.$refs.form.reset();

                    // Show success message
                    this.showSnackbar(
                        '¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.',
                        'success'
                    );
                } else {
                    // Show error if response doesn't indicate success
                    this.showSnackbar(
                        response.data.message || 'Ocurrió un error al enviar el mensaje.',
                        'error'
                    );
                }

            } catch (error) {
                console.error('Form submission error:', error);

                // Handle different types of errors
                let errorMessage = 'Ocurrió un error al enviar el mensaje. Por favor, inténtalo de nuevo.';

                if (error.response) {
                    // Server responded with error status
                    if (error.response.status === 422) {
                        // Validation errors
                        const errors = error.response.data.errors;
                        if (errors) {
                            // Get first error message
                            const firstError = Object.values(errors)[0];
                            errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;
                        } else if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        }
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                } else if (error.message) {
                    // reCAPTCHA or network errors
                    if (error.message.includes('reCAPTCHA')) {
                        errorMessage = 'Error de verificación de seguridad. Por favor, recarga la página e inténtalo de nuevo.';
                    } else {
                        errorMessage = 'Error de conexión. Por favor, verifica tu conexión a internet.';
                    }
                }

                // Show error message
                this.showSnackbar(errorMessage, 'error');

            } finally {
                this.loading = false;
            }
        },
        showSnackbar(message, color = 'success') {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },
        async getRecaptchaToken() {
            return new Promise((resolve, reject) => {
                if (typeof grecaptcha === 'undefined') {
                    reject(new Error('reCAPTCHA not loaded'));
                    return;
                }

                // Get site key from meta tag or window object
                const siteKey = document.querySelector('script[src*="google.com/recaptcha"]')?.src.match(/render=([^&]+)/)?.[1];

                if (!siteKey) {
                    reject(new Error('reCAPTCHA site key not found'));
                    return;
                }

                grecaptcha.ready(() => {
                    grecaptcha.execute(siteKey, {
                        action: 'contact_form'
                    })
                    .then(token => resolve(token))
                    .catch(error => reject(error));
                });
            });
        }
    },
}
</script>

<style>
/* Ensure snackbar has proper z-index */
.v-snack {
    z-index: 9999 !important;
}

/* Success Snackbar - Tailwind Green */
.success-snackbar .v-snack__wrapper {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
    box-shadow: 0 10px 25px -5px rgba(16, 185, 129, 0.3), 0 8px 10px -6px rgba(16, 185, 129, 0.2) !important;
    border-radius: 0.75rem !important;
    min-width: 380px !important;
    padding: 18px 24px !important;
}

/* Error Snackbar - Tailwind Red */
.error-snackbar .v-snack__wrapper {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    box-shadow: 0 10px 25px -5px rgba(239, 68, 68, 0.3), 0 8px 10px -6px rgba(239, 68, 68, 0.2) !important;
    border-radius: 0.75rem !important;
    min-width: 380px !important;
    padding: 18px 24px !important;
}

/* Snackbar content styling */
.v-snack__content {
    padding: 0 !important;
}

/* Animation enhancement */
.v-snack__wrapper {
    animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Close button hover effect */
.v-snackbar button:hover svg {
    transform: scale(1.1);
    transition: transform 0.2s ease;
}
</style>
